{
  "w": 56,
  "h": 36,
  "rows": [
    "........................................................",
    "........WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW........",
    ".....MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM.....",
    "...MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM...",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCMMMM",
    "MMMMccccccccccccccccccccccccccccccccccccccccccccccccMMMM",
    "MMMMccccccccccccccccccccccccccccccccccccccccccccccccMMMM",
    "MMMMccccccccccccccccccccccccccccccccccccccccccccccccMMMM",
    "MKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKM",
    "MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM",
    "MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM",
    "MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM",
    "MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmKKKKKKKKKKKKKKKKKKKKmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmKKKKKKKKKKKKKKKKKKKKmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmKKKKKKKKKKKKKKKKKKKKmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "RRRRKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKRRRR",
    "RRRRKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKRRRR",
    "RRRRKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKRRRR",
    "RRRRKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKRRRR",
    "RRRRKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKRRRR",
    "RRRRKmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmKRRRR",
    "MmmmmmmmmmmmmmmmmmmmmmmWWWWWWWWWWmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "KKKKWKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKWKKKK",
    "............KKKKKKK..................KKKKKKK............",
    "........................................................"
  ],
  "legend": {
    "K": "C.BLACK",
    "M": "C.B_MAGENTA",
    "m": "C.MAGENTA",
    "C": "C.B_CYAN",
    "c": "C.CYAN",
    "W": "C.B_WHITE",
    "R": "C.RED"
  }
}
